module.exports = __webpack_public_path__ + "img/layout_tree_left_right_icon.acd3d881.svg";